import createStore from "astrid-helpers/src/createStore";
export const [getContent, setContent, useContent] = createStore();
//# sourceMappingURL=content.js.map